$(document).ready(function () {
    //USER PROFILE SELECT ALL SCRIPT START
    $("input:checkbox#edit-field-regions-0,input:checkbox#edit-field-themes-0").click(function () {
        var chk = $(this).parent().siblings().children('.form-checkbox');
        if ($(this).prop("checked") === true) {
            chk.prop("checked", true);
        }
        if ($(this).prop("checked") === false) {
            chk.prop("checked", false);
        }
    });
    //USER PROFILE SELECT ALL SCRIPT END  
});
